import React from 'react'
import Header from '../../organisms/Header/Header'
import homepageBg from '../../../assets/images/homepage/homepagebg.webp'
import colors from '../../theme/color'
import CommonHeroSection from '../../organisms/commonherosection/CommonHeroSection'

const HeroSection = () => {
	return (
		<CommonHeroSection
			wrapperClassName="relative isolate min-h-[62vh] overflow-hidden lg:min-h-[68vh] min-[2560px]:flex min-[2560px]:min-h-[64vh] min-[2560px]:flex-col"
			contentClassName="relative z-20 flex w-full flex-col min-[2560px]:min-h-0 min-[2560px]:flex-1"
			backgroundImage={homepageBg}
			backgroundAlt="Gallery background"
		>
			<div className="pointer-events-none absolute inset-0 z-[1]" style={{ backgroundColor: `${colors.deepNavy}14` }} />
			<div
				className="pointer-events-none absolute inset-0 z-[1]"
				style={{ backgroundImage: `radial-gradient(circle at 18% 12%, ${colors.purpleAlt}12 0%, transparent 55%)` }}
			/>
			<div
				className="pointer-events-none absolute inset-0 z-[1]"
				style={{ backgroundImage: `radial-gradient(circle at 92% 22%, ${colors.purpleAlt}0F 0%, transparent 50%)` }}
			/>
			<div
				className="pointer-events-none absolute inset-0 z-[1]"
				style={{ backgroundImage: `linear-gradient(180deg, ${colors.deepNavy}00 0%, ${colors.deepNavy}14 40%, ${colors.deepNavy}47 100%)` }}
			/>

			<div>
				<Header />
			</div>

			<div className="flex flex-col items-center justify-center px-4 py-22 text-center md:py-28 lg:py-34 2xl:py-36 min-[2560px]:flex-1 min-[2560px]:justify-center min-[2560px]:py-10 min-[2560px]:pb-14 min-[2560px]:pt-2">
				<p className="mb-5 font-rajdhani text-[30px] font-gilroy-semibold leading-none text-purple-alt sm:text-[36px] md:text-[42px] 2xl:text-[52px] min-[2560px]:mb-7 min-[2560px]:text-[100px]">
					Our Gallery
				</p>

				<h2 className="font-rajdhani text-[40px] font-semibold leading-[0.98] text-white sm:text-[56px] md:text-[64px] 2xl:text-[76px] min-[2560px]:text-[152px]">
					We Work Hard, We Have Fun
				</h2>
				<h3 className="mt-3 font-rajdhani text-[40px] font-semibold leading-[0.98] text-purple-alt sm:text-[56px] md:text-[64px] 2xl:text-[76px] min-[2560px]:mt-6 min-[2560px]:text-[152px]">
					We Make a Difference!
				</h3>
			</div>
		</CommonHeroSection>
	)
}

export default HeroSection
